import styles from './AdminHeader.module.scss';

const AdminHeader = (props: any) => {
    return (
        <h1 className={styles["admin-header"]}>
            {props.children}
        </h1>
    );
}
export default AdminHeader;
